import { render, staticRenderFns } from "./HomeCollectionItem.vue?vue&type=template&id=8d083bac&scoped=true"
import script from "./HomeCollectionItem.vue?vue&type=script&lang=js"
export * from "./HomeCollectionItem.vue?vue&type=script&lang=js"
import style0 from "./HomeCollectionItem.vue?vue&type=style&index=0&id=8d083bac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d083bac",
  null
  
)

export default component.exports